import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export default function FormSkeleton() {
  return (
    <Box>
      <Skeleton variant="rounded" height={24} width="100%" sx={{ mb: 3 }} />

      <Box>
        <Skeleton variant="rounded" height={40} width={400} sx={{ mb: 2 }} />
        <Skeleton variant="rounded" height={40} width={400} sx={{ mb: 2 }} />
      </Box>

      <Box>
        <Skeleton variant="rounded" height={24} width={200} sx={{ ml: 2 }} />
      </Box>
    </Box>
  );
}
